<template>
    <div class="attrs-description" :data-key="dataKey">
        <div class="attrs-description__inner">
            <div class="attrs-description__close attrs-description__close--top" @click="hideAttributesDescription"
                @click.self="hideAttributesDescription">
                <span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20 2.31375L18.0613 0.375L10.375 8.06125L2.68875 0.375L0.75 2.31375L8.43625 10L0.75 17.6863L2.68875 19.625L10.375 11.9388L18.0613 19.625L20 17.6863L12.3138 10L20 2.31375Z"
                            fill="#3A3541" fill-opacity="0.54" />
                    </svg>
                </span>
            </div>

            <header class="attrs-description__header">
                <h4>{{ nameAttribute }} Details and Information</h4>
                <img class="attr-term-img" :src="selectedImage || firstGemstoneImage" alt=""
                    v-if="selectedImage || firstGemstoneImage">
            </header>

            <div class="attrs-description__select-item">
                <div class="attr-selector__heading">
                    <span class="name-attr">{{ nameAttribute }}:</span>
                    <div class="selectors-value">
                        <div class="attribute-selector" v-if="firstItemSelector" @click="showAttributeSelector">
                            <span class="selected-attribute">{{ selectedName || firstItemSelector }}</span>
                            <svg class="dropdown-icon" width="15" height="16" viewBox="0 0 15 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10.3687 5.86875L7.5 8.73125L4.63125 5.86875L3.75 6.75L7.5 10.5L11.25 6.75L10.3687 5.86875Z"
                                    fill="#212529" />
                            </svg>
                        </div>
                        <transition name="slide-fade">
                            <div class="list-attr-selector" v-show="isSelectorVisible">
                                <template v-if="isGemstoneItems">
                                    <template v-for="[key, items] in Object.entries(attributes)" :key="key">
                                        <h5 class="item__heading">{{ items?.[0]?.name_attr }}</h5>

                                        <div class="item__selector" v-for="item in items" :key="item.id"
                                            :data-id="item.id" @click="showAttributeSelectorDescription(item.id)">
                                            {{ item.name }}
                                        </div>
                                    </template>
                                </template>

                                <template v-else>
                                    <template v-for="item in attributes" :key="item.id" :data-id="item.id">
                                        <div class="item__selector" :data-id="item.id"
                                            @click="showAttributeSelectorDescription(item.id)">
                                            {{ item.name }}
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>

            <div class="attrs-description__detail">
                <transition-group name="fade">
                    <div v-for="(description, id) in data" :key="id" :data-name="`description-${id}`"
                        class="attrs-description__item-content" v-html="htmlSpecialcharsDecode(description)">
                    </div>
                </transition-group>

            </div>
            <div class="attrs-description__footer">
                <span @click="hideAttributesDescription"
                    class="attrs-description__close attrs-description__close--bottom">Done</span>
            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
import { computed, ref, onMounted } from 'vue';
interface AttributeItem {
    id: number;
    name: string;
    thumb?: string;
}
interface Props {
    nameAttribute: string;
    dataKey: string;
    data: Record<string, string>;
    attributes: Record<string, AttributeItem[]> | AttributeItem[];
}

const isSelectorVisible = ref(false);
const selectedKey = ref('');
const selectedImage = ref('');
const selectedName = ref('');
const attributesItems = ref<AttributeItem[]>([]);

const initializeAttributesItems = () => {
    if (isGemstoneItems.value) {
        attributesItems.value = (props.attributes as Record<string, AttributeItem[]>)[Object.keys(props.attributes)[0]];
    } else {
        attributesItems.value = props.attributes as AttributeItem[];
    }
};


const props = defineProps<Props>();



// const isGemstoneItems = computed(() => {
//     if (!props.attributes || typeof props.attributes !== 'object') {
//         return false;
//     }

//     const values = Object.values(props.attributes);
//     console.log(typeof (values[0]));
//     // typeof (values[0]) is object
//     return values.length > 0;
// });

const isGemstoneItems = computed(() => {
    // First check if attributes exists
    if (!props.attributes) {
        return false;
    }

    // Get the values
    const values = Object.values(props.attributes);

    // Check both length and if first item exists before checking its type
    if (values.length === 0 || !values[0]) {
        return false;
    }

    // Now we can safely check the type
    return typeof values[0] === 'object';
});


const firstGemstoneImage = computed(() => {
    if (!props.attributes) {
        return '';
    }

    if (isGemstoneItems.value) {
        const firstGroup = Object.values(props.attributes)[0];
        return firstGroup[0]?.thumb || '';
    } else {
        if (Array.isArray(props.attributes) && props.attributes.length > 0) {
            return (props.attributes[0] as AttributeItem).thumb || '';
        }
    }

    return '';
});


const firstItemSelector = computed(() => {
    if (!props.attributes) {
        return '';
    }

    if (isGemstoneItems.value) {
        // const firstGroup = Object.values(props.attributes)[0];
        // if (Array.isArray(firstGroup) && firstGroup.length > 0) {
        //     return firstGroup[0].name || '';
        // }
        const firstGroup = Object.values(props.attributes)[0];
        return firstGroup[0]?.name || '';
    } else {
        if (Array.isArray(props.attributes) && props.attributes.length > 0) {
            return props.attributes[0].name || '';
        }
    }

    return '';
});
const hideAttributesDescription = () => {
    const activeDescription = document.querySelector('.attrs-description.active');
    if (activeDescription) {
        activeDescription.classList.remove('active');
        document.body.style.overflow = ''; // Restore body scrolling
    }
};
const showAttributeSelector = () => {
    isSelectorVisible.value = !isSelectorVisible.value;
};
const showAttributeSelectorDescription = (key: string) => {
    selectedKey.value = key;

    const items = attributesItems.value;
    const selectedItem = Object.values(items).find(item => item.id.toString() === key.toString());
    if (selectedItem) {
        selectedImage.value = selectedItem.thumb || '';
        selectedName.value = selectedItem.name || '';
    } else {
        selectedImage.value = '';
        selectedName.value = '';
    }
    const descriptions = document.querySelectorAll('.attrs-description__item-content');
    descriptions.forEach(desc => {
        (desc as HTMLElement).style.display = 'none';
    });

    const selectedDesc = document.querySelector(`[data-name="description-${key}"]`);
    if (selectedDesc) {
        (selectedDesc as HTMLElement).style.display = 'block';
    }

    isSelectorVisible.value = false;
};
const handleDescriptionClickOutside = (event: MouseEvent) => {
  const descriptionInner = document.querySelector('.attrs-description__inner')
  const infoAtt = document.querySelector('.infor-att')
  const clickedElement = event.target as HTMLElement

  // Don't close if clicking on info button or its children
  if (infoAtt && infoAtt.contains(clickedElement)) {
    return
  }
  
  if (descriptionInner && !descriptionInner.contains(clickedElement)) {
    const activeDescription = document.querySelector('.attrs-description.active')
    if (activeDescription) {
      activeDescription.classList.remove('active')
      document.body.style.overflow = 'auto'
    }
  }
}
onMounted(() => {
    const firstDesc = document.querySelector('.attrs-description__item-content');
    if (firstDesc) {
        (firstDesc as HTMLElement).style.display = 'block';
    }
    initializeAttributesItems();
    document.addEventListener('click', handleDescriptionClickOutside)
});
onUnmounted(() => {
  document.removeEventListener('click', handleDescriptionClickOutside)
})
</script>